import { connect } from 'react-redux';
import React, { useState } from 'react';
import { default as __ } from '../../utils';
import { colors } from '../../styles';
import IO from '../../components/io';
import { default as UI_ACTIONS } from '../../reducers/ui';
import { default as SESSION_ACTIONS } from '../../reducers/session';
import { UserPala } from '../../components/padel/pala';
import Repeat from '../../components/utils/repeat';
import Shape from '../../components/utils/shape';
import { default as API } from '../../api';

let MAX_PALAS = 4;

const ConnectedPala = ({ user, notifyUser, tryAddPala,tryremovePala }) => {
  const { sessionId, palas } = user;
  const [userInput, setUserInput] = useState(() =>
    __.unwrapIterable(palas.reverse()), // palas.filter(p => p.sponsored)
  );

  const update = vals => setUserInput(vals);

  const submit = () => {
    let newPala = {
      ...userInput,
      id: palas.length,
    };

    // API.findDocument(sessionId)
    API.updateKey(sessionId, 'palas', [...palas, newPala])
      .then(_ =>
        __.callAll(tryAddPala(newPala), notifyUser('', false, 'success')),
      )
      .catch(o_O => notifyUser(o_O.code, 'sticky', 'fail'));
  };

  const deletePala = (pala)=> {
      const newPalas = palas.filter(p=>p.nickname !== pala.nickname);
        API.updateKey(sessionId, 'palas', newPalas)
      .then(_ =>
        __.callAll(tryremovePala(pala), notifyUser('', false, 'success')),
      )
      .catch(o_O => notifyUser(o_O.code, 'sticky', 'fail'));
  }

  return (
    <div className="small-container owl">
      <div className="grid grid--4 grid-gap-xl">
        {palas.map(p => (
          <UserPala key={p.id} {...p}  cb={()=> deletePala(p)}/>
        ))}
        <Repeat dummy times={MAX_PALAS - palas.length}>
          {({ i }) => <UserPala key={i} dummy />}
        </Repeat>
      </div>

      {palas.length <= MAX_PALAS ? (
        <>
          <IO.Form
            a11yTitle="Añade una pala nueva"
            report={vals => update(vals)}
            formId={'pala'}
            tracking={{
              brand: userInput['brand'],
              nickname: userInput['nickname'],
              style: userInput['style'],
            }}
            grid={2}
          >
            <IO.Text name="brand" label="Brand" />
            <IO.Text name="nickname" label="Nickname" />

            <IO.RadioGroup name="style" grid="2">
              <IO.Radio
                name="attack"
                label={({ checked }) => (
                  <Shape.Square
                    dummy
                    size={60}
                    fill={checked ? colors.accent : colors.accent_alpha}
                  />
                )}
              />
              <IO.Radio
                name="control"
                label={({ checked }) => (
                  <Shape.Hexa
                    dummy
                    size={60}
                    fill={checked ? colors.accent : colors.accent_alpha}
                  />
                )}
              />
            </IO.RadioGroup>
          </IO.Form>
                   <div className="col-center align-center owl">
                <button
                type="button"
                className="io-unbutton pill-button txt-uppercase"
                onClick={submit}
              >
                Guardar pala
              </button>
              {/* <p className="txt-uppercase txt-center txt-l -purple">
                {`${userInput['nickname']} ${userInput['style']} de ${userInput['brand']} `}
              </p> */}
            
            </div>
            <br aria-hidden="true"/>
        </>
      ) : null}
    </div>
  );
};

const select = state => {
  return {
    user: state.session.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    notifyUser: msg => dispatch(UI_ACTIONS.showFeedback(msg)),
    tryAddPala: pala => dispatch(SESSION_ACTIONS.addPala(pala)),
    tryremovePala: pala => dispatch(SESSION_ACTIONS.removePala(pala)),
  };
};

const Pala = connect(select, mapDispatchToProps)(ConnectedPala);

export default Pala;
